<pg-header
  title="Organization"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="gridData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="Organization List"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="cursor-pointer tblEdtBtn" (click)="onEdit2(data)">
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
          </div></ng-template
        >
        <!--
          <app-grid-column [showInColumnChooser]="false" [visible]="(USER_PERMISSIONS.dlte_in==1)?true:false"
          type="buttons" [width]="100" caption="Delete" cellTemplate="delTemplate"></app-grid-column>
          <ng-template appGridCell="delTemplate" let-data="cell"><div>
            <div class="cursor-pointer tblDelBtn">
              <div nz-popconfirm nzPopconfirmTitle="Are you sure deleting this item?" [nzIcon]="iconTpl" nzPopconfirmPlacement="topLeft" (nzOnConfirm)="confirm(data)" nzOkType="danger"
                nzOkText="YES" nzCancelText="NO" (nzOnCancel)="cancel()" >
                Delete
              </div>
            </div>
          </div></ng-template>
          <ng-template #iconTpl>
            <i nz-icon nzType="question-circle-o" style="color: red;"></i>
          </ng-template>
          -->
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="350"
    [nzVisible]="visible"
    nzTitle="{{ formDetails.stngs.form_title }}"
    (nzOnClose)="close()"
  >
    <div class="inptLbl">Organization</div>
    <nz-input-wrapper [nzSuffix]="inputClearTpl">
      <input
        nz-input
        [formControl]="name"
        placeholder="please enter organization"
      />
    </nz-input-wrapper>
    <ng-template #inputClearTpl
      >@if (formDetails.stngs.oper_mode == 'edit' || formDetails.stngs.oper_mode
      == 'delete') {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="frmcntl()"
      ></i>
      }</ng-template
    >
    @if (formDetails.stngs.oper_mode == 'new') {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveFormData(name.value)"
    >
      Submit
    </button>
    } @if (formDetails.stngs.oper_mode == 'edit') {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveFormData(name.value)"
    >
      Update
    </button>
    } @if (formDetails.stngs.oper_mode == 'delete') {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure deleting this organization?"
      [nzIcon]="iconTpl"
      nzPopconfirmPlacement="left"
      [nzPopconfirmShowArrow]="false"
      (nzOnConfirm)="confirm(name.value)"
      nzOkType="danger"
      nzOkText="YES"
      nzCancelText="NO"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    }
    <button nz-button nzType="default" class="cnclBtn" (click)="cancelbtn()">
      Cancel
    </button>
    <ng-template #iconTpl>
      <i nz-icon nzType="question-circle-o" style="color: red"></i>
    </ng-template>
  </nz-drawer>
  <!-- </div>
</div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
